import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 20,
	viewBox: "0 0 40 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4512 13.834V15H25.9219V13.834H30.4512ZM26.3379 6.46875V15H24.8672V6.46875H26.3379ZM29.8594 10.0312V11.1797H25.9219V10.0312H29.8594ZM30.4219 6.46875V7.64062H25.9219V6.46875H30.4219ZM38.4199 6.46875V15H36.9492L33.123 8.88867V15H31.6523V6.46875H33.123L36.9609 12.5918V6.46875H38.4199Z",
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 9.5,
			fill: "white",
			stroke: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_204_4727",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 1,
			y: 1,
			width: 18,
			height: 18,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 10,
				cy: 10,
				r: 9,
				fill: "#FCFCFC"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_204_4727)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 3.9248,
					y: 16.975,
					width: 12.375,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 3.9248,
					y: 16.975,
					width: 12.375,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.2251,
					y: 12.475,
					width: 17.775,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.2251,
					y: 12.475,
					width: 17.775,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.2251,
					y: 7.75,
					width: 17.775,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.2251,
					y: 7.75,
					width: 17.775,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.2251,
					y: 3.25,
					width: 17.775,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.2251,
					y: 3.25,
					width: 17.775,
					height: 2.25,
					fill: "#D90026"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1,
					y: 1,
					width: 9.225,
					height: 9,
					fill: "#0052B5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.4249 8.53748L7.7499 8.87498L7.9749 8.19998L7.5249 7.74998H8.1999L8.4249 7.07498L8.7624 7.74998H9.3249L8.8749 8.19998L9.0999 8.87498L8.4249 8.53748Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.275 8.53748L4.6 8.87498L4.825 8.19998L4.375 7.74998H5.05L5.275 7.07498L5.6125 7.74998H6.175L5.725 8.19998L5.95 8.87498L5.275 8.53748Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.1251 8.53748L1.4501 8.87498L1.6751 8.19998L1.2251 7.74998H1.9001L2.1251 7.07498L2.4626 7.74998H3.0251L2.5751 8.19998L2.8001 8.87498L2.1251 8.53748Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.4249 6.06252L7.7499 6.40002L7.9749 5.72502L7.5249 5.27502H8.1999L8.4249 4.60002L8.7624 5.27502H9.3249L8.8749 5.72502L9.0999 6.40002L8.4249 6.06252Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.4249 3.5875L7.7499 3.925L7.9749 3.25L7.5249 2.8H8.1999L8.4249 2.125L8.7624 2.8H9.3249L8.8749 3.25L9.0999 3.925L8.4249 3.5875Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.4249 1.11248L7.7499 1.44998L7.9749 0.774979L7.5249 0.324979H8.1999L8.4249 -0.350021L8.7624 0.324979H9.3249L8.8749 0.774979L9.0999 1.44998L8.4249 1.11248Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.275 3.5875L4.6 3.925L4.825 3.25L4.375 2.8H5.05L5.275 2.125L5.6125 2.8H6.175L5.725 3.25L5.95 3.925L5.275 3.5875Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.275 6.06252L4.6 6.40002L4.825 5.72502L4.375 5.27502H5.05L5.275 4.60002L5.6125 5.27502H6.175L5.725 5.72502L5.95 6.40002L5.275 6.06252Z",
					fill: "#EFEFEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.1251 6.06252L1.4501 6.40002L1.6751 5.72502L1.2251 5.27502H1.9001L2.1251 4.60002L2.4626 5.27502H3.0251L2.5751 5.72502L2.8001 6.40002L2.1251 6.06252Z",
					fill: "#EFEFEF"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgLangMui);
export { ForwardRef as ReactComponent };
